<mat-dialog-content>
  <form [formGroup]="form">
    <div class="flex-start-center flex-direction-row">
      @if (isEditor) {
        <button mat-flat-button color="accent" (click)="enableDisableChanges()">
          <mat-icon>edit</mat-icon>
          {{ (enableChangesTraduction$|async)!|translate }}
        </button>
      }
      <button mat-flat-button color="primary" (click)="addPidConfigurations()"
        [disabled]="(enableChanges$|async)==false">
        {{ 'newPidConfigurations'|translate }}&nbsp;<mat-icon>add</mat-icon>
      </button>

    </div>
    <mat-accordion>
      @for (pidConfiguration of pidConfigurations$|async; track pidConfiguration; let indexPid = $index) {
        <mat-expansion-panel (opened)="enableDisableUpdate()"
          >
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ 'pid_configuration.actuator'|translate }}&nbsp;{{ pidConfiguration.actuator|transformValueByPredicateFunction:getSensorNamePredicate:data.elements }}
            </mat-panel-title>
            <mat-panel-description class="flex-between-center">
              {{ 'pid_configuration.numberInputs'|translate }}&nbsp;{{ pidConfiguration.inputs ? pidConfiguration.inputs.length : 0 }}
              <div>
                @if (isEditor) {
                  <button mat-icon-button color="accent" style="margin-left: 5px"
                    [disabled]="(enableChanges$|async)==false"
                    (click)="$event.stopPropagation();clonePidConfigurations(indexPid)">
                    <mat-icon>content_copy</mat-icon>
                  </button>
                }
                @if (isEditor) {
                  <button mat-icon-button color="warn"
                    [disabled]="(enableChanges$|async)==false"
                    (click)="$event.stopPropagation();removePidConfigurations(indexPid)">
                    <mat-icon>delete</mat-icon>
                  </button>
                }
              </div>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="w100 border-color-primary flex-start-center flex-direction-row">
            <div>
              <app-increment-field
                [disabled]="(enableChanges$|async)==false"
                [currentValue]="pidConfiguration|transformValueByPredicateFunction:getPidConfigurationMs_between_executions"
                [step]="1"
                [min]="0"
                (changeValue)="setMs_between_executions($event,indexPid)"
                title="{{'pid_configuration.ms_between_executions'|translate}}"
                >
              </app-increment-field>
            </div>
            <div>
              <mat-label style="margin: 0 10px"
                class="color-contrast-theme">
                {{ 'season'|translate }}
              </mat-label>
              <mat-button-toggle-group
                [hideSingleSelectionIndicator]="true"
                [value]="pidConfiguration|transformValueByPredicateFunction:getPidSeason">
                @for (pValue of seasonTypes|transformValueByPredicateFunction:predicateSensoEventEnum; track pValue) {
                  @if (pValue|transformValueByPredicateFunction:getIconTypePredicate; as typeIcon ) {
                    <mat-button-toggle [value]="pValue.valueForm"
                      (click)="setSeason(pValue.valueForm,indexPid)"
                      [disabled]="(enableChanges$|async)==false"
                      >
                      @if (typeIcon.icon) {
                        <mat-icon [matTooltip]="typeIcon.tooltipText|translate"
                          class="icon-size-small_medium">{{ typeIcon.icon }}
                        </mat-icon>
                      } @else {
                        <mat-icon [matTooltip]="typeIcon.tooltipText|translate"
                          svgIcon="{{typeIcon.svgIcon}}"
                          class="icon-size-small_medium">
                        </mat-icon>
                      }
                      <ng-template #SVGICON>
                        <mat-icon [matTooltip]="typeIcon.tooltipText|translate"
                          svgIcon="{{typeIcon.svgIcon}}"
                          class="icon-size-small_medium">
                        </mat-icon>
                      </ng-template>
                    </mat-button-toggle>
                  }
                }
              </mat-button-toggle-group>
            </div>
          </div>
          <div class="w100 box-actuator box-outline border-color-primary flex-start-center flex-direction-row">
            <div style="margin-left: 5px">
              <button mat-flat-button color="primary" (click)="addInput(indexPid,undefined)"
                [disabled]="(enableChanges$|async)==false">
                {{ 'newInputs'|translate }}&nbsp;<mat-icon>add</mat-icon>
              </button>
            </div>
            @for (input of pidConfiguration.inputs; track input; let indexInput = $index) {
              <div class="box-input" (click)="addInput(indexPid,indexInput)">
                @if (enableChanges$|async) {
                  <div style="position: relative;right: 0;top:0;z-index: 1;transform: translate(calc(100% - 47px), 100%);">
                    <button mat-icon-button (click)="$event.stopPropagation();removeInput(indexPid,indexInput)">
                      <mat-icon>clear</mat-icon>
                    </button>
                  </div>
                }
                <ng-container
                  [ngTemplateOutlet]="BOXINPUT"
                  [ngTemplateOutletContext]="input"
                  >
                </ng-container>
              </div>
            }
          </div>
          <div (click)="addActuators(indexPid)">
            <div>
              @if (enableChanges$|async) {
                <div style="position: relative;right: 0;top:0;z-index: 1;transform: translate(calc(100% - 47px), 100%);">
                  <button mat-icon-button (click)="$event.stopPropagation(); removeActuators(indexPid)">
                    <mat-icon>clear</mat-icon>
                  </button>
                </div>
              }
              <ng-container
                [ngTemplateOutlet]="BOXACTUATOR"
                [ngTemplateOutletContext]="pidConfiguration.actuator!"
                >
              </ng-container>
            </div>
          </div>
        </mat-expansion-panel>
      }
    </mat-accordion>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button style="margin-right: 5px"
    color="accent" mat-flat-button
    mat-dialog-close>
    <mat-icon>clear</mat-icon>
  </button>
  <ng-container>
    @if (isEditor) {
      <button color="primary" mat-flat-button
        (click)="clickSaveButton()">
        <mat-icon>save</mat-icon>
      </button>
    }
  </ng-container>
</mat-dialog-actions>


<ng-template #BOXACTUATOR let-command="command" let-infoName="infoName" let-sensorId="sensorId" let-minValue="minValue"
  let-maxValue="maxValue">
  <div>{{ 'pid_configuration.actuator'|translate }}</div>
  @if (command!=null||infoName!=null||sensorId!=null) {
    <div class=" box-actuator flex-start-start flex-direction-row">
      <div class="box-outline border-color-primary margin-card-field-actuator">
        <div class="secondary-text">
          {{ 'pid_configuration.sensor'|translate }}
        </div>
        @if (sensorId) {
          <div class="primary-text">
            {{ sensorId|transformValueByPredicateFunction:getElementNamePredicate:data.elements }}
          </div>
        }
      </div>
      <div class="box-outline border-color-primary margin-card-field-actuator">
        <div class="secondary-text">
          {{ 'pid_configuration.possibleCommand'|translate }}
        </div>
        @if (command) {
          <div class="primary-text">
            {{ 'possibleCommands.' + command|translate }}
          </div>
        }
      </div>
      <div class="box-outline border-color-primary margin-card-field-actuator">
        <div class="secondary-text">
          {{ 'pid_configuration.infoName'|translate }}
        </div>
        @if (infoName) {
          <div class="primary-text">
            {{ infoName|sensorDataTraduction$|async }}
          </div>
        }
      </div>
      <div class="box-outline border-color-primary margin-card-field-actuator">
        <div class="secondary-text">
          {{ 'pid_configuration.minValue'|translate }}
        </div>
        @if (minValue!=null) {
          <div class="primary-text">
            {{ minValue }}
          </div>
        }
      </div>
      <div class="box-outline border-color-primary margin-card-field-actuator">
        <div class="secondary-text">
          {{ 'pid_configuration.maxValue'|translate }}
        </div>
        @if (maxValue!=null) {
          <div class="primary-text">
            {{ maxValue }}
          </div>
        }
      </div>
    </div>
  } @else {
    <button mat-flat-button color="primary" [disabled]="(enableChanges$|async)==false">
      {{ 'pid_configuration.configureActuator'|translate }}
    </button>
  }
  <ng-template #BUTTONCONFIGUREACTUATOR>
    <button mat-flat-button color="primary" [disabled]="(enableChanges$|async)==false">
      {{ 'pid_configuration.configureActuator'|translate }}
    </button>
  </ng-template>
</ng-template>
<ng-template #ACTUATORFIELD>
  <mat-dialog-content>
    <form [formGroup]="form">
      <div formGroupName="actuatorField" class="flex-direction-column flex-start-center">
        <div class="flex-start-center flex-direction-row w100">
          @if (data.elements) {
            <app-form-field-select-with-filter class=" box-min-max"
              [possibleValues]="data.elements"
              formControlName="sensorId"
              [idsUsed]="(pidConfigurations$|async)|transformValueByPredicateFunction:getActuatorIdsUsedPredicate"
              >
            </app-form-field-select-with-filter>
          }
          @if ((actuatorFieldSensorId$|async)|transformValueByPredicateFunction:getPossibleCommandsPredicate:data.elements; as possibleCommands) {
            <mat-form-field class=" box-min-max" style="margin-left: -7px;margin-right: 7px"
              >
              <mat-label>{{ 'pid_configuration.possibleCommand'|translate }}</mat-label>
              <mat-select formControlName="command">
                @for (pCommand of possibleCommands; track pCommand) {
                  <mat-option
                    [value]="pCommand">{{ 'possibleCommands.' + pCommand|translate }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }

          @if (actuatorFieldSensorPValues$|async; as pValues) {
            <div class="box-min-max">
              <app-auto-complete-form
                formControlName="infoName"
                [title]="'pid_configuration.infoName'|translate"
                [itemsGroup]="pValues"
                appearance="outline"
                [hiddenClearButton]="true"
                >
                <!--                                <div prefix>-->
                <!--                                    <button mat-icon-button matPrefix-->
                <!--                                            (click)="$event.stopPropagation();unsetValue('sensorDataType')">-->
                <!--                                        <mat-icon>cancel</mat-icon>-->
              <!--                                    </button>-->
            <!--                                </div>-->
          </app-auto-complete-form>
        </div>
      }
      <mat-divider style="margin-top: 10px"></mat-divider>
    </div>
    <div class="flex-start-center flex-direction-row w100">
      <app-increment-field class="box-min-max"
        title="{{'pid_configuration.minValue'|translate}}"
        formControlName="minValue"
        >

      </app-increment-field>
      <app-increment-field
        class="box-min-max"
        title="{{'pid_configuration.maxValue'|translate}}"
        formControlName="maxValue">

      </app-increment-field>
    </div>
  </div>
</form>
@if (errorActuatorField$|async; as errorActuatorField) {
  <mat-error>{{ errorActuatorField|translate }}
  </mat-error>
}
</mat-dialog-content>
<mat-dialog-actions>
  <button color="accent"
    mat-flat-button

    matTooltip="{{'button.close' | translate}}" (click)="closeDialogActuator()">
    <mat-icon>clear</mat-icon>
  </button>
  <button class="fab" color="primary"
    mat-flat-button
    [disabled]="invalidActuatorField$|async"
    matTooltip="{{'button.save' | translate}}" (click)="clickSaveActuators()">
    <mat-icon>add</mat-icon>
  </button>
</mat-dialog-actions>
</ng-template>
<ng-template #INPUTFIELD>
  <mat-dialog-content>
    <form [formGroup]="form">
      <div formGroupName="inputField" class="flex-direction-row flex-start-center">
        <div class="w100">
          <div class="subtitle text-color-primary">
            {{ 'pid_configuration.source'|translate }}
          </div>
          <div class="flex-start-center flex-direction-row">
            @if (data.elements) {
              <app-form-field-select-with-filter class="margin-field"
                [possibleValues]="data.elements"
                [idsUsed]="(pidConfigurations$|async)|transformValueByPredicateFunction:getInputsIdsUsedPredicate"
                formControlName="sensorId"
                >
              </app-form-field-select-with-filter>
            }
            @if (inputFieldSensorPValues$|async; as pValues) {
              <div class="margin-field">
                <app-auto-complete-form
                  formControlName="infoName"
                  [title]="'pid_configuration.infoName'|translate"
                  [itemsGroup]="pValues"
                  appearance="outline"
                  [hiddenClearButton]="true"
                  >
                  <!--                                <div prefix>-->
                  <!--                                    <button mat-icon-button matPrefix-->
                  <!--                                            (click)="$event.stopPropagation();unsetValue('sensorDataType')">-->
                  <!--                                        <mat-icon>cancel</mat-icon>-->
                <!--                                    </button>-->
              <!--                                </div>-->
            </app-auto-complete-form>
          </div>
        }
      </div>
      <mat-divider style="margin-top: 10px"></mat-divider>
    </div>
    <div class="w100">
      <div class="subtitle text-color-primary">
        {{ 'pid_configuration.target'|translate }}
      </div>
      <div class="flex-start-center flex-direction-row">
        <mat-button-toggle-group formControlName="type" class="margin-field">
          <mat-button-toggle
            [value]="possibleTypesTargetInput.FIXED">{{ 'pid_configuration.fixed'|translate }}
          </mat-button-toggle>
          <mat-button-toggle
            [value]="possibleTypesTargetInput.SENSOR">{{ 'pid_configuration.sensor'|translate }}
          </mat-button-toggle>
          <mat-button-toggle
            [value]="possibleTypesTargetInput.SCENARIO">{{ 'pid_configuration.scenario'|translate }}
          </mat-button-toggle>
        </mat-button-toggle-group>
        <mat-button-toggle-group formControlName="target_op" class="margin-field">
          <mat-button-toggle [value]="possibleTypesTargetOp.LESS">
            <div class="w100 flex-between-center">
              <mat-icon svgIcon="<" style="margin: 5px"></mat-icon>
              <span class="visualized-in-desktop">{{ ('operator.<')|translate }}</span>
            </div>
          </mat-button-toggle>
          <mat-button-toggle [value]="possibleTypesTargetOp.EQUAL">
            <div class="w100 flex-between-center">
              <mat-icon svgIcon="=" style="margin: 5px"></mat-icon>
                                    <span class="visualized-in-desktop">{{ ('operator.=')|translate }}</span>
                                </div>
                            </mat-button-toggle>
                            <mat-button-toggle [value]="possibleTypesTargetOp.GREATER">
                                <div class="w100 flex-between-center">
                                    <mat-icon svgIcon=">" style="margin: 5px"></mat-icon>
                                    <span class="visualized-in-desktop">{{ ('operator.>')|translate }}</span>
                                </div>
                            </mat-button-toggle>
                        </mat-button-toggle-group>
                        
@switch (typeTargetField$|async) {
                            @case (possibleTypesTargetInput.SENSOR) {

                                <ng-container formGroupName="targetSensor">
                                    @if (data.elements) {
<app-form-field-select-with-filter class="margin-field"
                                                                      
                                                                       [possibleValues]="data.elements"
                                                                       formControlName="sensorId"
                                    >
                                    </app-form-field-select-with-filter>
}
                                    @if (inputTargetFieldSensorPValues$|async; as pValues) {
                                        <div class="margin-field">
                                            <app-auto-complete-form
                                                    formControlName="infoName"
                                                    [title]="'pid_configuration.infoName'|translate"
                    [itemsGroup]="pValues"
                    appearance="outline"
                    [hiddenClearButton]="true"
                    >
                    <!--                                <div prefix>-->
                    <!--                                    <button mat-icon-button matPrefix-->
                    <!--                                            (click)="$event.stopPropagation();unsetValue('sensorDataType')">-->
                    <!--                                        <mat-icon>cancel</mat-icon>-->
                  <!--                                    </button>-->
                <!--                                </div>-->
              </app-auto-complete-form>
            </div>
          }
        </ng-container>
      }
      @case (possibleTypesTargetInput.SCENARIO) {
        <ng-container formGroupName="targetScenario">
          @if (data.elements) {
            <app-form-field-select-with-filter class="margin-field"
              [possibleValues]="data.elements|transformValueByPredicateFunction:getOnlyElementsWhitCategoryTHERMOSTAT"
              formControlName="sensorId"
              >
            </app-form-field-select-with-filter>
          }
        </ng-container>
      }
      @default {
        <app-increment-field class="box-min-max"
          title="{{'pid_configuration.value'|translate}}"
          formControlName="target"
          >
        </app-increment-field>
      }
    }
  </div>
  <mat-divider></mat-divider>
</div>

<div class="w100">
  <div class="subtitle text-color-primary">
    {{ 'pid_configuration.parameter'|translate }}
  </div>
  <div class="flex-start-center flex-direction-row">
    <app-increment-field class="box-min-max"
      title="{{'pid_configuration.max_step_down'|translate}}"
      [min]="0"
      [step]="1"
      formControlName="max_step_down"
      >

    </app-increment-field>
    <app-increment-field class="box-min-max"
      title="{{'pid_configuration.max_step_up'|translate}}"
      [min]="0"
      [step]="1"
      formControlName="max_step_up"
      >
    </app-increment-field>
    <app-increment-field class="box-min-max"
      title="{{'pid_configuration.i_max'|translate}}"
      formControlName="i_max"
      >

    </app-increment-field>
    <app-increment-field class="box-min-max"
      title="{{'pid_configuration.k_i'|translate}}"
      formControlName="k_i"
      >

    </app-increment-field>
    <app-increment-field class="box-min-max"
      title="{{'pid_configuration.k_d'|translate}}"
      formControlName="k_d"
      >

    </app-increment-field>
    <app-increment-field
      class="box-min-max"
      title="{{'pid_configuration.k_p'|translate}}"
      formControlName="k_p">

    </app-increment-field>
  </div>
</div>
</div>
</form>
@if (errorInputField$|async; as errorInputField) {
  <mat-error>{{ errorInputField|translate }}</mat-error>
}
</mat-dialog-content>
<mat-dialog-actions>
  <button color="accent"
    mat-flat-button
    matTooltip="{{'button.close' | translate}}" (click)="closeDialogInput()">
    <mat-icon>clear</mat-icon>
  </button>
  <button class="fab" color="primary"
    mat-flat-button
    [disabled]="invalidInputField$|async"
    matTooltip="{{'button.save' | translate}}" (click)="clickSaveInput()">
    <mat-icon>add</mat-icon>
  </button>
</mat-dialog-actions>
</ng-template>
<ng-template #BOXINPUT
  let-infoName="infoName" let-sensorId="sensorId"
  let-type="type"
  let-target_op="target_op"
  let-target="target"
  let-k_i="k_i" let-k_d="k_d" let-k_p="k_p"
  let-i_max="i_max"
  let-max_step_up="max_step_up"
  let-max_step_down="max_step_down">
  <mat-card style="margin: 5px">
    <mat-card-content>
      <div class="w100">
        <div class="subtitle text-color-primary">
          {{ 'pid_configuration.source'|translate }}
        </div>
        <div class="flex-start-center flex-direction-row">
          <div class="flex-start-start flex-direction-column">

            @if (sensorId) {
              <div class="margin-field">
                <div class="subtitle primary-text">
                  {{ 'pid_configuration.sensor'|translate }}
                </div>
                <div>
                  {{ sensorId|transformValueByPredicateFunction:getElementNamePredicate:data.elements }}
                </div>
              </div>
            }
            <!--                    <div *ngIf="type" class="margin-field">-->
            <!--                        <div class="subtitle primary-text">-->
            <!--                            {{'pid_configuration.type'|translate}}-->
          <!--                        </div>-->
          <!--                        <div>-->
          <!--                            {{(type == possibleTypesTargetInput.FIXED ? 'pid_configuration.sensorValue' : 'pid_configuration.fixed')|translate}}-->
        <!--                        </div>-->
      <!--                    </div>-->
      @if (infoName) {
        <div class="margin-field">
          <div class="subtitle primary-text">
            {{ 'pid_configuration.infoName'|translate }}
          </div>
          <div>
            {{ infoName|sensorDataTraduction$|async }}
          </div>
        </div>
      }
    </div>

    @if (target_op!=null) {
      <div class="margin-field">
        <div class="subtitle primary-text">
          {{ 'pid_configuration.targetOp'|translate }}
        </div>
        <div>
          @switch (target_op) {
            @case (possibleTypesTargetOp.LESS) {
              <mat-icon svgIcon="<" style="margin: 5px"></mat-icon>
            }
            @case (possibleTypesTargetOp.EQUAL) {
              <mat-icon svgIcon="=" style="margin: 5px"></mat-icon>
            }
            @case (possibleTypesTargetOp.GREATER) {
              <mat-icon svgIcon=">" style="margin: 5px"></mat-icon>
            }
          }
        </div>
      </div>
    }
    @if (target) {
      <div class="margin-field">
        @switch (type) {
          @case (possibleTypesTargetInput.SENSOR) {
            <div class="subtitle primary-text">
              {{ 'pid_configuration.sensorValue'|translate }}
            </div>
            @if (target&&target.sensorId) {
              @if (target.sensorId) {
                {{ target.sensorId|transformValueByPredicateFunction:getElementNamePredicate:data.elements }}
              }
              @if (target.infoName) {
                <div class="subtitle primary-text">
                  {{ 'pid_configuration.infoName'|translate }}
                </div>
                <div>
                  {{ target.infoName|sensorDataTraduction$|async }}
                </div>
              }
            }
          }
          @case (possibleTypesTargetInput.SCENARIO) {
            <div class="subtitle primary-text">
              {{ 'pid_configuration.scenario'|translate }}
            </div>
            @if (target) {
              @if (target.sensorId) {
                {{ target.sensorId|transformValueByPredicateFunction:getElementNamePredicate:data.elements }}
              }
            }
          }
          @default {
            <div class="subtitle primary-text">
              {{ 'pid_configuration.value'|translate }}
            </div>
            {{ target }}
          }
        }
      </div>
    }

  </div>
</div>
<!--            <div class="w100">-->
<!--                <div class="subtitle text-color-primary">-->
<!--                    {{'pid_configuration.costant'|translate}}-->
<!--                </div>-->
<!--                <div class="flex-start-center flex-direction-row">-->
<!--                    <div *ngIf="k_i" class="margin-field">-->
<!--                        <div class="subtitle primary-text">-->
<!--                            {{'pid_configuration.k_i'|translate}}-->
<!--                        </div>-->
<!--                        <div>-->
<!--                            {{k_i}}-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div *ngIf="k_d" class="margin-field">-->
<!--                        <div class="subtitle primary-text">-->
<!--                            {{'pid_configuration.k_d'|translate}}-->
<!--                        </div>-->
<!--                        <div>-->
<!--                            {{k_d}}-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div *ngIf="k_p" class="margin-field">-->
<!--                        <div class="subtitle primary-text">-->
<!--                            {{'pid_configuration.k_p'|translate}}-->
<!--                        </div>-->
<!--                        <div>-->
<!--                            {{k_p}}-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <mat-divider></mat-divider>-->
<!--            </div>-->
<!--            <div class="w100">-->
<!--                <div class="subtitle text-color-primary">-->
<!--                    {{'pid_configuration.parameter'|translate}}-->
<!--                </div>-->
<!--                <div class="flex-start-center flex-direction-row">-->
<!--                    <div *ngIf="max_step_down!=null" class="margin-field">-->
<!--                        <div class="subtitle primary-text">-->
<!--                            {{'pid_configuration.max_step_down'|translate}}-->
<!--                        </div>-->
<!--                        <div>-->
<!--                            {{max_step_down}}-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div *ngIf="max_step_up!=null" class="margin-field">-->
<!--                        <div class="subtitle primary-text">-->
<!--                            {{'pid_configuration.max_step_up'|translate}}-->
<!--                        </div>-->
<!--                        <div>-->
<!--                            {{max_step_up}}-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div *ngIf="i_max!=null" class="margin-field">-->
<!--                        <div class="subtitle primary-text">-->
<!--                            {{'pid_configuration.i_max'|translate}}-->
<!--                        </div>-->
<!--                        <div>-->
<!--                            {{i_max}}-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <mat-divider></mat-divider>-->
<!--            </div>-->
</mat-card-content>
</mat-card>
</ng-template>


